import { render, staticRenderFns } from "./UserRegRootComponent.vue?vue&type=template&id=2c20d7ef&scoped=true"
import script from "./UserRegRootComponent.vue?vue&type=script&lang=js"
export * from "./UserRegRootComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c20d7ef",
  null
  
)

export default component.exports